// src/pages/Home.jsx
import React from 'react';
import Hero from "../components/Hero/Hero.jsx";
import CategorySlider from "../components/productSlider/Slider.jsx";
import ShopByRecipient from "../components/ShopByRecipient/ShopByRecipient.jsx";
import SpiritualCollection from "../components/SpiritualCollection/SpiritualCollection.jsx";

const Home = () => {
  return (
    <>
      <Hero />
      <CategorySlider />
      <ShopByRecipient />
      <SpiritualCollection />
    </>
  );
};

export default Home;
